import { Injectable } from '@angular/core';

import { CustomHttpService } from './custom-http.service';
import { HttpOptionsModel } from '../models';

@Injectable()
export class ProfileService {

  constructor(private customHttpService: CustomHttpService) {

  }

  updateProfile(data) {
    let httpOptions = new HttpOptionsModel('/profile/update', data, false, true);
    return this.customHttpService.post(httpOptions);
  }

  updatePassword(data) {
    let httpOptions = new HttpOptionsModel('/profile/update/password', data, false, true);
    return this.customHttpService.post(httpOptions);
  }

  getTransactionHistory() {
    let httpOptions = new HttpOptionsModel('/profile/transactions', null, false, true);
    return this.customHttpService.post(httpOptions);
  }

  getGameHistory(startDate:string, endDate:string){
    let postData = {
      start_date: startDate,
      end_date: endDate
    }
    let httpOptions = new HttpOptionsModel('/game-history', postData, false, true);
    return this.customHttpService.post(httpOptions);
  }

}



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/services/profile.service.ts